import React from 'react'
import CDropdownItem from './CDropdownItem'

//component - CoreUI / CDropdownHeader

const CDropdownHeader = props => {

  return (
    <CDropdownItem {...props} header/>
  )
}

export default CDropdownHeader
